import { getFunctions, httpsCallable } from 'firebase/functions';

export interface IcsCalendar {
  id: string; name: string; url: string; color: string; type: 'ics' | 'apple';
}

export interface IcsCalendarEvent {
  id: string; rawEventId: string; calendarId: string; calendarName?: string;
  calendarColor?: string; calendarType?: string; accountEmail: string;
  title: string; start: string; end: string; isAllDay: boolean;
  location?: string; description?: string;
}

class IcsCalendarService {
  private fn = httpsCallable<{ action: string; [key: string]: unknown }, Record<string, unknown>>(
    getFunctions(), 'icsCalendar'
  );

  async add(name: string, url: string, color: string, type: 'ics' | 'apple' = 'ics'): Promise<{ calendarId: string }> {
    return (await this.fn({ action: 'add', name, url, color, type })).data as { calendarId: string };
  }

  async list(): Promise<IcsCalendar[]> {
    return ((await this.fn({ action: 'list' })).data as { calendars: IcsCalendar[] }).calendars;
  }

  async remove(calendarId: string): Promise<void> {
    await this.fn({ action: 'remove', calendarId });
  }

  async getEvents(start: Date, end: Date): Promise<IcsCalendarEvent[]> {
    return ((await this.fn({ action: 'getEvents', startIso: start.toISOString(), endIso: end.toISOString() })).data as { events: IcsCalendarEvent[] }).events;
  }
}

export const icsCalendarService = new IcsCalendarService();
